import { render, staticRenderFns } from "./ModalDashboardAgendamento.vue?vue&type=template&id=33ee3cf2&scoped=true"
import script from "./ModalDashboardAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalDashboardAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalDashboardAgendamento.vue?vue&type=style&index=0&id=33ee3cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee3cf2",
  null
  
)

export default component.exports